<template src="./Index.html">
</template>

<script>

    export default {
        created() {

        },
        model: {
            prop: "employee",
        },

        props: ["employee"],
        computed: {},
        data() {
            return {
                
            }
        },
        methods: {
            remove(){

            },
            nextStep() {
           this.$emit("nextStep");
            },
           
        },
    };
</script>
